export default __webpack_public_path__ + "static/media/request_prize-stap_05.8d47f9a0.png";